var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voteomatic main-page",attrs:{"id":"voteomatic"}},[(_vm.isElection)?_c('election-module'):(_vm.isPublicPmode)?_c('public-pmode'):_c('meeting-module'),_vm._v(" "),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }